/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Retry_ButtonInputs */

const en_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const id_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba lagi`)
};

const ms_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba semula`)
};

const ca_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna-ho a intentar`)
};

const cs_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opakovat`)
};

const da_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igen`)
};

const de_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const et_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proovi uuesti`)
};

const es_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const fr_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const hr_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokušaj ponovo`)
};

const it_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const lv_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēģināt vēlreiz`)
};

const lt_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandyti dar kartą`)
};

const hu_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Újra`)
};

const nl_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer opnieuw`)
};

const nb_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv på nytt`)
};

const pl_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponów`)
};

const pt_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const ro_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reîncearcă`)
};

const sk_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skúsiť znova`)
};

const sl_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poskusi znova`)
};

const fi_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritä uudestaan`)
};

const sv_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Försök igen`)
};

const vi_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

const tr_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar Dene`)
};

const el_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προσπαθήστε ξανά`)
};

const bg_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторен опит`)
};

const ru_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить попытку`)
};

const sr_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробај поново`)
};

const uk_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спробувати знову`)
};

const ka_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ხელახლა ცდა`)
};

const hi_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुन: प्रयास करें`)
};

const th_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองใหม่`)
};

const ko_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

const zh_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_tw_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重試`)
};

const ja_retry_button = /** @type {(inputs: Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Retry_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const retry_button = /** @type {((inputs?: Retry_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Retry_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_retry_button(inputs)
	if (locale === "ms") return ms_retry_button(inputs)
	if (locale === "ca") return ca_retry_button(inputs)
	if (locale === "cs") return cs_retry_button(inputs)
	if (locale === "da") return da_retry_button(inputs)
	if (locale === "de") return de_retry_button(inputs)
	if (locale === "et") return et_retry_button(inputs)
	if (locale === "es") return es_retry_button(inputs)
	if (locale === "fr") return fr_retry_button(inputs)
	if (locale === "hr") return hr_retry_button(inputs)
	if (locale === "it") return it_retry_button(inputs)
	if (locale === "lv") return lv_retry_button(inputs)
	if (locale === "lt") return lt_retry_button(inputs)
	if (locale === "hu") return hu_retry_button(inputs)
	if (locale === "nl") return nl_retry_button(inputs)
	if (locale === "nb") return nb_retry_button(inputs)
	if (locale === "pl") return pl_retry_button(inputs)
	if (locale === "pt") return pt_retry_button(inputs)
	if (locale === "ro") return ro_retry_button(inputs)
	if (locale === "sk") return sk_retry_button(inputs)
	if (locale === "sl") return sl_retry_button(inputs)
	if (locale === "fi") return fi_retry_button(inputs)
	if (locale === "sv") return sv_retry_button(inputs)
	if (locale === "vi") return vi_retry_button(inputs)
	if (locale === "tr") return tr_retry_button(inputs)
	if (locale === "el") return el_retry_button(inputs)
	if (locale === "bg") return bg_retry_button(inputs)
	if (locale === "ru") return ru_retry_button(inputs)
	if (locale === "sr") return sr_retry_button(inputs)
	if (locale === "uk") return uk_retry_button(inputs)
	if (locale === "ka") return ka_retry_button(inputs)
	if (locale === "hi") return hi_retry_button(inputs)
	if (locale === "th") return th_retry_button(inputs)
	if (locale === "ko") return ko_retry_button(inputs)
	if (locale === "zh") return zh_retry_button(inputs)
	if (locale === "zh-tw") return zh_tw_retry_button(inputs)
	if (locale === "ja") return ja_retry_button(inputs)
	return en_retry_button(inputs)
});